import React from 'react';
import cn from 'classnames';

import styles from './ParkingBlock.module.scss';

import ParkingSlot from './ParkingSlot';

export default function ParkingBlock(props) {

  var elements = []
  var cnt = 0;
  props.parkingBlocks.forEach(function (elem) {
    cnt++;
    elements.push(
      <div key={cnt} className={cn(styles.parking_container_block, styles.parking_container_block_layout)}>

        <ParkingSlot key={cnt} parkingSlots={elem}></ParkingSlot>

      </div>);
  });

  return (
    <div>
      {elements}
    </div>
  );
}
